'use client';

import { usePathname, useRouter } from 'next/navigation';
import { IconArrowRight1 } from '@/features/icons';
import { pageTitles } from '@/app/profile/orders/constants';
import useUser from '@/utils/use-user';
import { useCartReturnUrl } from '../cart/_utils/use-cart-return-url';
import { useLoginFromCart } from '../cart/_utils/use-login-from-cart';
const STATIC_FALLBACKS: Record<string, string> = {
  '/checkout/shipping': '/cart',
  '/checkout/payment': '/checkout/shipping'
};
export default function OrderHeader() {
  const pathname = usePathname();
  const router = useRouter();
  const {
    isLoggedIn
  } = useUser();
  const {
    returnUrl
  } = useCartReturnUrl();
  const {
    isNewLogin,
    setIsNewLogin
  } = useLoginFromCart();
  const isUserLoggedInNow = isNewLogin && isLoggedIn;
  const fallbackRoute = pathname === '/cart' ? returnUrl : STATIC_FALLBACKS[pathname] || '/';
  const goBack = () => {
    if (window.history.length > 2 && !isUserLoggedInNow) {
      router.back();
      return;
    }
    if (pathname === '/cart' && isUserLoggedInNow) {
      // SKIP Login pages and go to the last page before login
      window.history.go(-4);
      setIsNewLogin(false);
      return;
    }
    router.replace(fallbackRoute);
  };
  const pageTitle = pageTitles[pathname] || '';
  return <div className='sticky top-0 z-[1001] mb-2 flex min-h-14 items-center justify-center bg-white px-4 py-3 shadow-sm lg:hidden' data-sentry-component="OrderHeader" data-sentry-source-file="header.tsx">
            <IconArrowRight1 className='absolute right-2 h-6 w-6 cursor-pointer text-text-black' onClick={goBack} data-sentry-element="IconArrowRight1" data-sentry-source-file="header.tsx" />
            <span className='mt-1 text-body-16 font-medium text-text-black'>{pageTitle}</span>
        </div>;
}